const Manga = ({ series_id: id, locale: { enUS }, url }) => ({
  id,
  name: enUS.name,
  image: enUS.full_image_url,
  url: `/comics/manga${url}/volumes`,
});

export { Manga };
